<template>
  <div>
    <div class="shippingHistoryTable">
      <v-data-table
        :headers="headersTmp"
        :items="propsItems"
        :item-key="itemKey"
        :hide-default-header="false"
        hide-default-footer
        class="rounded-lg"
        :items-per-page="-1"
        :no-data-text="$t('common.common_no-history')"
      >
        <template v-slot:item="row">
          <tr>
            <td>{{ row.item.created_at_formatted }}</td>
            <td>{{ row.item.user.fullName }}</td>
            <td>{{ row.item.orderReason }}</td>
            <td
              v-html="showTextWithNewLine(row.item.content)"
              class="custom-pre"
            ></td>
            <td>{{ incompleteOrderStatus(row.item.status) }}</td>
            <td>
              <NormalButton
                v-if="resolvedStatus(row.item.status)"
                :text="$t('common.input_unresolve')"
                class="mr-2"
                btnClass="pa-2"
                height="32px"
                color="white"
                textColor="thinText--text"
                :outlined="true"
                @click="
                  unresolveNotification(
                    row.item.incomplete_for_customer_order_id
                  )
                "
              />
              <NormalButton
                v-else
                :text="$t('common.input_resolve')"
                class="mr-2"
                btnClass="pa-2"
                height="32px"
                color="white"
                textColor="thinText--text"
                :outlined="true"
                @click="
                  deleteNotification(row.item.incomplete_for_customer_order_id)
                "
              />
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import NormalButton from '@/components/items/Buttons/NormalButton'
import { mapActions } from 'vuex'
import { saleStatusHistory } from '@/config'

export default {
  name: 'IncompleteNotificationHistoryTable',
  components: {
    NormalButton
  },
  props: {
    headers: [],
    propsItems: {
      type: Array,
      require: true,
      default: () => []
    },
    itemKey: String,
    recItems: {
      type: Object,
      require: false,
      default: () => ({})
    }
  },
  data: () => ({
    paymentIdName: ''
  }),
  created() {},
  methods: {
    ...mapActions('Sale', [
      'deleteIncompleteNotification',
      'unresolveIncompleteNotification'
    ]),
    async deleteNotification(notificationId) {
      if (!confirm(this.$t('sale.sale_delete_incomplete_notification_confirm')))
        return

      const params = {
        notificationId: notificationId,
        saleId: this.recItems.saleId
      }
      const isSuccess = await this.deleteIncompleteNotification(params)
      if (!isSuccess) return
      this.$emit('complete')
    },
    async unresolveNotification(notificationId) {
      if (
        !confirm(this.$t('sale.sale_delete_incomplete_notification_unconfirm'))
      )
        return

      const params = {
        notificationId: notificationId,
        saleId: this.recItems.saleId
      }
      const isSuccess = await this.unresolveIncompleteNotification(params)
      if (!isSuccess) return
      this.$emit('complete')
    },
    showTextWithNewLine(text) {
      return (
        '<pre style="font-family: \'Roboto\', sans-serif; white-space: pre-wrap">' +
        text
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;') +
        '</pre>'
      )
    },
    incompleteOrderStatus(status) {
      if (status === saleStatusHistory.INCOMPLETE_ORDER_STATUS.RESOLVE) {
        return this.$t('common.common_resolved')
      } else {
        return this.$t('common.common_not-resolved')
      }
    },
    resolvedStatus(status) {
      return status === saleStatusHistory.INCOMPLETE_ORDER_STATUS.RESOLVE
    }
  },
  computed: {
    headersTmp() {
      if (!Array.isArray(this.headers)) {
        return []
      }
      const headersTmp = this.headers.map((header) => {
        if (!this.isOperation) {
          if (header.value === 'operationId') {
            header.text = ''
            header.value = 'noDisplay'
          }
        }
        const tmp = { ...header }
        tmp.text = this.$t(tmp.text)
        return tmp
      })
      return headersTmp
    },
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.shippingHistoryTable {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    padding-left: 30px;
  }
  ::v-deep .v-data-table td {
    padding-left: 30px;
  }
}
.normalNumberInput {
  width: 180px;
}
</style>
